module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/child.svg?16f655e672bb56eb2c904a72c0ab5f02";